<template>
    <div class="leadsQunSide">
        <div class="titleTop">
            过滤器
        </div>
        <div>
            <div class="filterName">
                <span class="checked">所有群</span>
                <span></span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "leadsQunSide",
        data(){
            return{

            }
        }
    }
</script>

<style scoped lang="less">
.leadsQunSide{
    height: calc(100vh - 140px);
    .titleTop{
        display: flex;
        height: 40px;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #dddddd;
        color: #927f7f;
        margin: 0 10px;
        font-size: 13px;
    }
    .filterName{
        height: 48px;
        margin: 0 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
    }
    .checked{
        color: #409eff;
    }
}
</style>